<fieldset [disabled]="disableControl">
    <div class="mb-3">
        <label for="" class="mb-1" *ngIf="false">UPLOAD Generic File</label>
        <div class="input-group custom-file-button">
            <input type="file" class="form-control" [id]="inputFIleID" #fileInput
                (change)="onFileSelected($event, inputFIleID!)" [accept]="acceptedFileTypes"
                [multiple]="allowMultipleFiles">
            <label class="input-group-text" [for]="inputFIleID">UPLOAD</label>
        </div>
    </div>

   
    <!-- <div *ngIf="showAdditionalInfo">
        <div class="row" *ngFor="let fileInfo of selFiles; let i = index">
            <div class="col-md-12 ps-0">
                <span id="">
                    <span id="filesList">
                        <div class="file-container"></div>
                        <a class="fw-bold file-name" (click)="onFileDownload($event, i)">

                            <span id="files-names"> {{fileInfo!.fileName!}}
                                <img src="assets/images/icons8-delete.svg" alt="Delete Icon" class="delete-icon"
                                    *ngIf="fileInfo!.fileName! != null && fileInfo!.fileName!.length > 0"
                                    (click)="removeFile(inputFIleID!, i)">
                            </span>
                        </a>

                    </span>
                </span>
            </div>






<!-- old code for reference once functionality tested will remov-->


             <!-- <div class="row" *ngIf="showAdditionalInfo">
        <div class="col-md-2" [ngClass]="{'disabled-row': disableAfterReview}">
            <img src="assets/images/close_mark.svg" alt="" 
                *ngIf="selectedFiles!.fileName! != null && selectedFiles!.fileName!.length > 0" 
                (click)="removeFile(inputFIleID!)">
        </div>
        <div class="col-md-7 ps-0">
            <a href="#" class="fw-bold" style="color:#0c9ef1; text-decoration: none;"
                (click)="onFileDownload($event)">
            {{selectedFiles!.fileName!}}</a>
        </div>
        <div class="col-md-3 text-end" *ngIf="totalCount > 0 ? true: false">
            <p class="mb-0">{{selectedFiles!.rowsTotalCount!}}</p>
        </div>
    </div> -->






            <!-- <div class="col-md-3 text-end" *ngIf="totalCount > 0 ? true: false">
                <p class="mb-0">{{fileInfo!.rowsTotalCount!}}</p>
            </div> -->

            <div *ngIf="showAdditionalInfo">
                <div class="row" *ngFor="let fileInfo of selFiles; let i = index">
                    <div class="col-md-2" [ngClass]="{'disabled-row': disableAfterReview}">
                        <img src="assets/images/close_mark.svg" alt="" 
                            *ngIf="fileInfo!.fileName! != null && fileInfo!.fileName!.length > 0" 
                            (click)="removeFile(inputFIleID!, i)">
                    </div>
                    <div class="col-md-10 ps-0">
                        <a href="#" class="fw-bold" style="color:#0c9ef1; text-decoration: none;"
                            (click)="onFileDownload($event, i)">
                        {{fileInfo!.fileName!}}</a>
                    </div>
                    <div class="col-md-3 text-end" *ngIf="totalCount > 0 ? true: false">
                        <p class="mb-0">{{fileInfo!.rowsTotalCount!}}</p>
                    </div>
                </div>
            </div>
            
     

</fieldset>